import { motion, useReducedMotion } from "framer-motion";
import { CornerFlora, HeartMotif } from "./decor";

export const PricePill = ({ price, idPrefix }) => {
  const reduce = useReducedMotion();
  return (
    <motion.span
      data-testid={`${idPrefix}-price`}
      className="inline-flex shrink-0 items-center rounded-full bg-[#9B2C2C] px-4 py-1.5 font-serif text-base font-semibold text-white"
      initial={reduce ? false : { scale: 0.8, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ type: "spring", stiffness: 260, damping: 14 }}
    >
      ₹{price}
    </motion.span>
  );
};

export const DishCard = ({ item, index = 0, idPrefix }) => (
  <motion.article
    data-testid={`${idPrefix}-dish-card`}
    className="group relative overflow-hidden rounded-[12px] border border-[#E8B4B8]/30 bg-white/80 p-6 pb-8 shadow-[0_6px_24px_rgba(155,44,44,0.07)] backdrop-blur-sm transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:scale-[1.02] hover:shadow-[0_18px_44px_rgba(201,162,39,0.22)]"
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
  >
    <CornerFlora className="absolute -right-3 -top-3 h-16 w-16 rotate-90 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
    <div className="flex items-start justify-between gap-3">
      <h3 className="font-serif text-xl font-semibold leading-snug text-[#9B2C2C]">{item.name}</h3>
      <PricePill price={item.price} idPrefix={idPrefix} />
    </div>
    <p className="mt-3 text-sm leading-relaxed text-[#B86B77]">{item.desc}</p>
    <div className="absolute bottom-2.5 left-1/2 -translate-x-1/2 text-[#E8B4B8] opacity-70 transition-all duration-500 group-hover:text-[#C9A227] group-hover:opacity-100">
      <HeartMotif className="h-3.5 w-3.5" />
    </div>
  </motion.article>
);
